import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";
import AddEditXMLReports from "./components/addEditXMLReports/AddEditXMLReports";
import "./XMLReports.scss";

/** Lazily Loaded Components */
const XMLReportsList = lazy(() =>
  import("./components/xMLReportsList/XMLReportsList")
);

const XMLReports = () => {

  const molGridRef = useRef(null);

  const [isEdit, setIsEdit] = useState(false);
  const [editXMLReportsData, seteditXMLReportsData] = useState(null);
  const [isXMLReportsModelOpen, setIsXMLReportsModelOpen] = useState(false);

  const handleAddXMLReportsClick = () => {
    setIsXMLReportsModelOpen(true);
    seteditXMLReportsData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsXMLReportsModelOpen(false);
    seteditXMLReportsData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsXMLReportsModelOpen(true);
    seteditXMLReportsData(data);
    setIsEdit(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="xml-reports-sec">
        <CardSection
          cardTitle={"XML Reports"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddXMLReportsClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
        <div className="only-list-body-scroll">
            <XMLReportsList ref={molGridRef} onEdit={handleEditClick} />
          </div>
        </CardSection>
        
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update XML Report` : `Add XML Report`}
        modalSize={"w-50"}
        isOpen={isXMLReportsModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditXMLReports
          isEdit={isEdit}
          isOpen={isXMLReportsModelOpen}
          initData={editXMLReportsData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>
    </>
  );
};

export default XMLReports;
